import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalTree from "root/Modals/ViewFamily/ModalTree";

const useModalTree = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, members: null, title: null })  ;

    const onClickActivate = ( members, title ) =>
    {
        setDialog ({ openState: true, members, title });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, key: null, members: null, title: null });
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalTree onClose={onCloseModal} members={dialog.members} title={dialog.title} />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalTree ;
